// using same in blog and widgets to reuse code
export const IS_VIEW_COUNT_ENABLED = 'blog-isViewCountEnabled';
export const IS_VIEW_COUNT_ENABLED_PATH = `style.booleans.${IS_VIEW_COUNT_ENABLED}`;

export const CARD_BACKGROUND_COLOR = 'post-cardBackgroundColor';
export const CARD_BACKGROUND_COLOR_PATH = `style.colors.${CARD_BACKGROUND_COLOR}`;

export const POST_TITLE_FONT = 'post-titleFont';

export const POST_TITLE_COLOR = 'post-titleColor';
export const POST_TITLE_COLOR_PATH = `style.colors.${POST_TITLE_COLOR}`;

export const POST_DESCRIPTION_FONT = 'post-descriptionFont';

export const POST_DESCRIPTION_COLOR = 'post-descriptionColor';
export const POST_DESCRIPTION_COLOR_PATH = `style.colors.${POST_DESCRIPTION_COLOR}`;

export const POST_HOVER_COLOR = 'post-hoverColor';
export const POST_HOVER_COLOR_PATH = `style.colors.${POST_HOVER_COLOR}`;

export const CARD_BORDER_COLOR = 'post-cardBorderColor';
export const CARD_BORDER_COLOR_PATH = `style.colors.${CARD_BORDER_COLOR}`;

export const CARD_BORDER_WIDTH = 'post-cardBorderWidth';
export const CARD_BORDER_WIDTH_PATH = `style.numbers.${CARD_BORDER_WIDTH}`;

export const WIDGET_BACKGROUND_COLOR = 'widget-backgroundColor';
export const WIDGET_BACKGROUND_COLOR_PATH = `style.colors.${WIDGET_BACKGROUND_COLOR}`;
